import {Exclude, Expose} from "class-transformer";
import {AbstractDictionaryApiModel} from "./abstract-dictionary.api-model";

@Exclude()
export class VehicleTypeApiModel extends AbstractDictionaryApiModel {
  @Expose() code: string;
}
